module.exports = __webpack_public_path__ + "img/order.31001d87.svg";